<template>
  <div id="tapefileupload">
    <FilePond  
        allow-multiple="true" 
        :allowPaste="true"
        v-on:init="handleFilePondInit"
        v-on:updatefiles="handleFilePondUpdateFile"
    />
  </div>
</template>
<script>
import vueBioFilePond from 'vue-filepond';
import '../../../assets/css/filepond.min.css';
import FilePondPluginBioImagePreview from 'filepond-plugin-image-preview';
import '../../../assets/css/filepond-plugin-image-preview.min.css';

export default {
    name: 'biofileupload',
    components: {
        FilePond: vueBioFilePond(FilePondPluginBioImagePreview)
    },
    data() {
        return {
            bioFiles:[],
        }
    },
    methods: {
        handleFilePondInit () {
            console.log('FilePond(bio) has initialized')
            // FilePond instance methods are available on `this.$refs.pond`
        },
        onload (e, r) {
        },
        
        handleFilePondUpdateFile(files){
            this.bioFiles = files.map(files => files.file);
            this.$emit('bioFileHandler', this.bioFiles);
        },
    },
}
</script>


// WEBPACK FOOTER //
// src/views/Common/image-upload/bioUpload.vue